import { Fragment } from "react"
import { JobProfileTableStyle } from "../job-profile-table/JobProfileTableStyle"

export const TABLE_SKILLS_ITEMS = [
	{
		name: "type_name",
		label: "Tipo",
		props: {},
	},
	{
		name: "name",
		label: "Nombre",
		props: {},
	},
]
export function JobProfileSkillsTable({ label, data, onEdit, actions, onDelete }) {
	return (
		<Fragment>
			<JobProfileTableStyle
				{...{
					items: TABLE_SKILLS_ITEMS,
					data,
					onDelete,
					onEdit,
					actions,
				}}
			/>
		</Fragment>
	)
}
